var poll_header_default = {
  "title": "F0lOw",
  "image": "PMy-G",
  "webview": "_2gTW-"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
